import styled from 'styled-components'
import Div from "./Div";

const FlexDiv = styled(Div)`
	display: flex;
`

export default FlexDiv;